document.addEventListener('DOMContentLoaded', function () {
  const body = document.body;
  const menuInTopElement = document.getElementById('home-menu-treshold');

  if (
    (body.classList.contains('index') ||
      body.classList.contains('page-pasion-cta') ||
      body.classList.contains('page-equilibrio-cta') ||
      body.classList.contains('page-laspizarras')  ||
      body.classList.contains('page-new'))    &&
    menuInTopElement
  ) {
    function checkScrollPosition() {
      const elementRect = menuInTopElement.getBoundingClientRect();
      const elementTop = elementRect.top + window.scrollY;
      const currentScroll = window.scrollY;

      if (currentScroll >= elementTop) {
        body.classList.add('menu-in-top');
      } else {
        body.classList.remove('menu-in-top');
      }
    }

    checkScrollPosition();

    window.addEventListener('scroll', checkScrollPosition);
  }
});
